import React from "react";
import { database, storage } from "../../Firebase/firebase";
function AdminSkills() {
  const [skills, setSkills] = React.useState([]);
  const [tools, setTools] = React.useState([]);
  const [type, setType] = React.useState("skills");
  const [uploadState, setUploadState] = React.useState(false);
  const imageRef = React.useRef();
  const [title, setTitle] = React.useState("");
  const addSkills = () => {
    if (imageRef.current?.files[0]?.name && title) {
      if (imageRef.current?.files[0]?.type.includes("image")) {
        setUploadState(true);
        const uploadTask = storage
          .ref(`${type}/${imageRef.current.files[0].name}`)
          .put(imageRef.current.files[0]);

        uploadTask.on(
          "state_changed",
          (snapshot) => {
            // setPostState(Math.floor((snapshot.bytesTransferred/snapshot.totalBytes)*100)+1)
          },
          (error) => {},
          () => {
            storage
              .ref(type)
              .child(imageRef.current.files[0].name)
              .getDownloadURL()
              .then((url) => {
                database.collection(type).add({
                  title,
                  image: url,
                  imagePath: imageRef.current.files[0].name,
                });
                setTitle("");
                setUploadState(false);
              });
          }
        );
      }
    }
  };
  const deleteSkill = (id, imagePath) => {
    database.collection("skills").doc(id).delete();
    if (imagePath) storage.ref(`skills/${imagePath}`).delete();
  };
const deleteTool = (id, imagePath) => {
  database.collection("tools").doc(id).delete();
  if (imagePath) storage.ref(`tools/${imagePath}`).delete();
};

  React.useEffect(() => {
    const unsubscribe = database.collection("skills").onSnapshot((docs) => {
      setSkills(docs.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    });
    const unsubscribe2 = database.collection("tools").onSnapshot((docs) => {
      setTools(docs.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    });
    return () => {
      unsubscribe();
      unsubscribe2();
    };
  }, []);

  return (
    <div className="adminSkillsContainer flexBox">
      <div className="addSkill flexBox">
        <h1>Add new skill/Tool</h1>
        <input
          type="text"
          placeholder="Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />
        <select value={type} onChange={(e)=>setType(e.target.value)}>
          <option value="skills">Skill</option>
          <option value="tools">Tool</option>
        </select>
        <input type="file" ref={imageRef} required />
        <button disabled={uploadState} onClick={addSkills}>
          SUBMIT
        </button>
      </div>
      <h1>Skills</h1>
      <div className="skillsBox flexBox">
        {skills.map((skill) => (
          <div
            key={skill.id}
            className="flexBox"
            onClick={() => deleteSkill(skill.id, skill.imagePath)}
          >
            <img src={skill.image} alt="logo" />
            <p>{skill.title}</p>
          </div>
        ))}
      </div>
      <h1>Tools</h1>
      <div className="skillsBox flexBox">
        {tools.map((skill) => (
          <div
            key={skill.id}
            className="flexBox"
            onClick={() => deleteTool(skill.id, skill.imagePath)}
          >
            <img src={skill.image} alt="logo" />
            <p>{skill.title}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AdminSkills;
